import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  /* ================= LOGIN ================= */
  const login = (data) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("refreshToken", data.refreshToken);

    const userData = {
      userId: data.user_Id,
      name: data.user_Name,
      roleId: data.roleId,
      role: data.roleName,
      userTypeId: data.userTypeId,
      userTypeName: data.userTypeName,
      restaurantId: data.restId,
      restaurantName: data.restaurantName,
      groupId: data.groupId,
      groupName: data.groupName,
      mobileNo: data.mobileNo,
    };

    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.clear();
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);